/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GroupToRoleMapping } from '../models/GroupToRoleMapping';

export class SamlIdentityProvider {
  /**
  * The ID of the identity provider
  */
  'id': string;
  /**
  * The name of the identity provider
  */
  'providerName': string;
  /**
  * The SSO URL of the identity provider
  */
  'ssoUrl': string;
  /**
  * The logout URL of the identity provider
  */
  'logoutUrl'?: string;
  /**
  * The issuer URL of the identity provider
  */
  'issuerUrl': string;
  /**
  * The certificate of the identity provider
  */
  'certificate': string;
  /**
  * Whether authentication request signing and SP certificate validation is enabled for this IDP
  */
  'enableAuthenticationRequestSigning'?: boolean;
  'groupToRoleMappingList'?: Array<GroupToRoleMapping>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerName",
      "baseName": "providerName",
      "type": "string",
      "format": ""
    },
    {
      "name": "ssoUrl",
      "baseName": "ssoUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "logoutUrl",
      "baseName": "logoutUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "issuerUrl",
      "baseName": "issuerUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "certificate",
      "baseName": "certificate",
      "type": "string",
      "format": ""
    },
    {
      "name": "enableAuthenticationRequestSigning",
      "baseName": "enableAuthenticationRequestSigning",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "groupToRoleMappingList",
      "baseName": "groupToRoleMappingList",
      "type": "Array<GroupToRoleMapping>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SamlIdentityProvider.attributeTypeMap;
  }

  public constructor() {
  }
}

